/**
 * Labstep
 */

import React, { createContext } from 'react';
import type { ParamsContextType } from './types';

export const defaultParamsContext: ParamsContextType = {
  initialSearchParams: {},
  searchParams: {},
  injectFields: {},
  setParams: (): void => {},
  addPostFilter: (): void => {},
  clearAll: (): void => {},
  clearParams: (): void => {},
  setPostFilterNodeType: (): void => {},
  removePostFilter: (): void => {},
};

/**
 * Context for params to access searchParams, setParams and addPostFilter in children
 * without passing props down multiple levels.
 * TODO: Remove props passing completely and use context instead.
 */
export const ParamsContext = createContext<ParamsContextType>(
  defaultParamsContext,
);

export const ParamsContextProvider: RFC<{
  value: ParamsContextType;
}> = ({ value, children }) => {
  return <ParamsContext.Provider value={value} children={children} />;
};
